var map = {
	"./create-component": [
		83680
	],
	"./create-component.js": [
		83680
	],
	"./get-component": [
		82498
	],
	"./get-component.js": [
		82498
	],
	"./get-observable": [
		67185,
		7185
	],
	"./get-observable.js": [
		67185,
		7185
	],
	"./onElementDisposing": [
		25744,
		5744
	],
	"./onElementDisposing.js": [
		25744,
		5744
	],
	"./ref": [
		2542
	],
	"./ref.js": [
		2542
	],
	"./register-binding": [
		9920
	],
	"./register-binding.js": [
		9920
	],
	"./register-component": [
		72130
	],
	"./register-component.js": [
		72130
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2164;
module.exports = webpackAsyncContext;